import React from 'react'
import {Link} from "react-router-dom";
import logo from "../images/ab_logo.jpeg";

import "./Navbar.css"
function Navbar() {
  return (
    <div>
      <div className='fixed-top'>

        <nav className="navbar navbar-expand-lg navbar-white bg-white shadow">
  <div className="container-fluid">
    
    <Link to="/">
    <img src={logo}  height="79"  width="178" alt='logo'/>
    </Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link to="/" className="nav-link active" aria-current="page" href="#">Home</Link>
        </li>
        <li className="nav-item">
          <Link to="/about" className="nav-link" href="#">About us</Link>
        </li>
        <li className="nav-item">
          <Link to="/products" className="nav-link" href="#">Product</Link>
        </li>
        <li className="nav-item">
          <Link to="#" className="nav-link" href="#">Our Distributor</Link>
        </li>
         <li className="nav-item">
          <Link to="/gallery" className="nav-link" href="#">Gallery</Link>
        </li>
      
        <li className="nav-item">
          <Link to="/Contact" className="nav-link" href="#">Contact us</Link>
        </li>
      </ul>
     <a href='tel: 8509330871'>
        <div  className="btn-grad56" type="submit">Helpline Number</div>
        </a>
      
    </div>
  </div>
</nav>
</div>
    </div>
  )
}

export default Navbar